export default __webpack_public_path__ + "static/media/awar1.5da12385.jpg";